import IApi from 'modules/shared/domain/IApi';
import api from 'modules/shared/infrastructure/api/Api';
import BaseRepository from 'modules/shared/infrastructure/repositories/BaseRepository';
import * as URL from './urls';
import { UnloadingPointInfoListDTO } from '../dto/unloadingPointDTO';
import { UnloadingPointMapper } from '../mappers/unloadingPoint.mapper';
import { UnloadingPointInfo } from '../../domain/unloadingPoint';

class UnloadingPointRepository extends BaseRepository {
  private readonly _api: IApi;
  private readonly _apiGetUnloadingPointInfo: string;

  constructor({ api, apiGetUnloadingPointInfo }) {
    super();
    this._api = api;
    this._apiGetUnloadingPointInfo = apiGetUnloadingPointInfo;
  }

  getUnloadingPointInfoData(): Promise<UnloadingPointInfo> {
    return this._api.get(`${this._apiGetUnloadingPointInfo}`).then((res) => {
      const response = new UnloadingPointInfoListDTO(res);
      return UnloadingPointMapper.unloadingPointInfoListDtoToDomain(response);
    });
  }
}

export default new UnloadingPointRepository({
  api: api,
  apiGetUnloadingPointInfo: URL.API_GET_UNLOADING_POINT_INFO
});

export { UnloadingPointRepository };
